module.exports = __webpack_public_path__ + "img/ddf285f.jpg";